import { callApiToServer } from "../callApi";

export async function editCategory(authtoken, categoryObject, categoryId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      categoryId: categoryId,
      name: categoryObject.name,
      type: categoryObject.type,
      background: categoryObject.background,
      forground: categoryObject.forground,
      accent: categoryObject.accent,
      icon_name: categoryObject.icon_name,
    });

    let endUrl = "v1/auth/category";

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
